import React, {  } from 'react'
import { Divider } from '@mui/material'
import ApplicationInfo from 'components/ApplicationInfo'

import { makeStyles } from '@mui/styles'
import moment from 'moment'
import _ from 'lodash'
import { reviewStyles } from './styles'

export default function ComplementaryReviewInfo({ review }) {
  const classes = makeStyles(() => (reviewStyles))()
  const creationDate = review?.created || null
  
  return (
    <React.Fragment>
      <div className={classes.gappedItem}>
                <p>
          <span>Data de derivação para revisão: </span>
          {_.isEmpty(creationDate) ? '-' : moment(creationDate).format('DD/MM/yyyy HH:mm:ss')}
        </p>
        <h3>Informações Complementares</h3>


        <ApplicationInfo review={review}/>

   
      </div>
      <Divider flexItem />
    </React.Fragment>
  )
}
